import * as yup from "yup";
import { isValidPhoneNumber } from "libphonenumber-js";
import { usPhoneNumberRgx } from "./validation-patterns";
import { strToNumericStr } from "./form-converters";

export const getStringRequiredFieldMessage = (field: { label: string }) => {
  return `Missing ${field.label}`;
};

// export const getNumberRequiredFieldMessage = (field: {
//   label: string;
//   min: number;
// }) => {
//   return `${field.label} must be greater than ${field.min}`;
// };

export const validatePhoneNumber = (opts: {
  message: string;
  region: "US";
  optional?: boolean;
}): yup.TestFunction<any> =>
  function (value: string) {
    const { message, region, optional = false } = opts;

    const numericValue = strToNumericStr(value);

    const getErrorMessage = () =>
      this.createError({
        path: this.path,
        message,
      });

    if (optional && !numericValue?.trim()) {
      return true;
    }

    // Reject if more than 10 digits (US phone numbers should only have 10 digits)
    if (numericValue.length > 10) {
      return getErrorMessage();
    }

    // Reject if less than 10 digits
    if (numericValue.length < 10) {
      return getErrorMessage();
    }

    if (!numericValue.match(usPhoneNumberRgx)) {
      return getErrorMessage();
    }

    try {
      const isValid = isValidPhoneNumber(numericValue, region);

      if (isValid) return true;

      return getErrorMessage();
    } catch {
      return getErrorMessage();
    }
  };

export const validateGlobalPhoneNumber = (opts: {
  message: string;
  optional?: boolean;
}): yup.TestFunction<any> =>
  function (value: string) {
    const { message, optional = false } = opts;

    const trimmedValue = value?.trim() || "";

    const getErrorMessage = () =>
      this.createError({
        path: this.path,
        message,
      });

    if (optional && !trimmedValue) {
      return true;
    }

    if (!trimmedValue) {
      return getErrorMessage();
    }

    try {
      if (trimmedValue.startsWith("+")) {
        const internationalNumericPart = trimmedValue
          .slice(1)
          .replace(/\D/g, "");

        if (
          internationalNumericPart.length < 7 ||
          internationalNumericPart.length > 15
        ) {
          return getErrorMessage();
        }

        const isValid = isValidPhoneNumber(trimmedValue);

        if (isValid) return true;

        return getErrorMessage();
      }

      // US format without +
      const numericValue = strToNumericStr(trimmedValue);

      if (numericValue.length !== 10) {
        return getErrorMessage();
      }

      if (!numericValue.match(usPhoneNumberRgx)) {
        return getErrorMessage();
      }

      const isValid = isValidPhoneNumber(numericValue, "US");

      if (isValid) return true;

      return getErrorMessage();
    } catch {
      return getErrorMessage();
    }
  };
